module.exports = __webpack_public_path__ + "img/3_ava.2d611aa1.jpg";